<template>
  <div class="page">
    <div class="content">
      <div class="top">

        <template v-for="item in orderState.filter(el=>el.state===state.orderDetail?.orderState)"
                  :key="item.state">
          <div class="status">
            <div class="item-text">
              {{ item.state===4&&state.orderDetail?.cancelReason?'已退款':item.text }}
            </div>
            <div class="state-tip">
              <!-- <div class="tip"
                   v-if="item.state!==4">{{ item.tip }}</div>
              <div class="tip"
                   v-else>{{ orderDetail.data?.cancelReason }}</div> -->
              <div class="tip">{{ state.orderDetail.cancelReason }}</div>
            </div>
          </div>
        </template>

        <template v-if="!state.orderDetail">
          <div class="status">
            <div class="item-text"
                 style="opacity: 0;">
              NO_SHOW
            </div>
          </div>
        </template>

        <div class="price-box">
          <div class="item">
            <span>{{Number(state.orderDetail?.orderAmount?state.orderDetail?.orderAmount:0).toFixed(2)}}元</span>
            <span style="font-size: 1rem;">应付款</span>
          </div>
          <div class="item">
            <span>{{Number((state.orderDetail?.cardMoney||0)+(state.orderDetail?.cash||0)).toFixed(2)}}元</span>
            <span style="font-size: 1rem;">已付款</span>
          </div>
          <div class="item">
            <span>{{Number((state.orderDetail?.orderAmount?state.orderDetail?.orderAmount:0)-((state.orderDetail?.cardMoney||0)+(state.orderDetail?.cash||0))).toFixed(2)}}元</span>
            <span style="font-size: 1rem;">未付款</span>
          </div>
        </div>
      </div>

      <div class="box">
        <div class="title">商品信息</div>
        <div class="item">
          <span class="item-title">商品名称</span>
          <span class="item-content">{{state.orderDetail?.servOrderDetails[0].shop?.shopName}}</span>
        </div>
      </div>

      <div class="box">
        <div class="title">订单信息</div>
        <div class="item">
          <span class="item-title">订单号</span>
          <span class="item-content">{{state.orderDetail?.orderCode}}</span>
        </div>
        <div class="item">
          <span class="item-title">支付方式</span>
          <!-- 普康宝 || -- -->
          <span class="item-content">{{state.orderDetail?.servOrderPayment?.payType?payWayState.filter(el=>state.orderDetail?.servOrderPayment?.payType===el.state)[0].text:'-'}}</span>
        </div>
        <div class="item">
          <span class="item-title">下单时间</span>
          <span class="item-content">{{state.orderDetail?.servOrderDetails[0].createdAt}}</span>
        </div>
      </div>
    </div>

    <div class="bottom">
      <a :href="getServicePhoneTel()"
         class="customer">
        <img src="./images/customer-service.png">
        联系客服
      </a>
      <!-- 状态为 待支付 -->
      <div class="btns"
           v-if="state.orderDetail?.orderState===0">
        <van-button style="border-radius: 5px;width: 6rem;height:40px;"
                    color="#FF931F"
                    @click="toPay">
          去支付
        </van-button>
      </div>
      <!-- 状态为 已支付 -->
      <div class="btns"
           v-else-if="state.orderDetail?.orderState==1||state.orderDetail?.orderState==2||state.orderDetail?.orderState==3">
        <van-button style="border-radius: 5px;width: 6rem;margin-right: 0.5rem;height:40px;"
                    type="default"
                    v-if="isShowReturnBtn&&(state.orderDetail?.orderState==1||state.orderDetail?.orderState==2)"
                    @click="returnMoney">
          <!-- 此按钮仅当 卡券状态 为 待使用  and  当前日期-支付日期<=7天  show -->
          退款
        </van-button>
        <van-button style="border-radius: 5px;width: 6rem;height:40px;"
                    color="#FF931F"
                    @click="lookCardDetail">
          查看券码
        </van-button>
      </div>

    </div>

  </div>
</template>

<script>
import { Dialog, Toast } from 'vant'
import { useRoute, useRouter } from 'vue-router'
import axios from 'axios'
import { reactive, ref, watch } from 'vue'
import moment from 'moment'
import { getServicePhoneText, getServicePhoneTel } from '@/utils/common'
export default {
  setup () {

    const router = useRouter()
    const route = useRoute()
    const isShowReturnBtn = ref(true)

    const state = reactive({
      orderDetail: null
    })

    watch(() => state.orderDetail, val => {
      isShowReturnBtn.value = isBeforeAWeek(val.servOrderPayment?.createdAt)
    })

    const init = async () => {
      const res = await axios.get(`/PKECUser/servOrderDetail/${route.query.orderCode}`)
      console.log(res)
      if (res.errorCode === 0) {
        state.orderDetail = res.data
        console.log(state.orderDetail)
        const isRePay = sessionStorage.getItem('isRePay') || null
        if (res.data.orderState === 0 && isRePay) {
          sessionStorage.removeItem('isRePay')
          toPay()
        }
      } else {
        Toast(res.errorMessage)
      }
    }

    init()

    // 退款
    const returnMoney = () => {
      Dialog.confirm({
        title: '确定要将订单退款吗?',
        message: '已支付金额将于退款成功后1个工作日内原路返回',
      }).then(async () => {
        let res = await axios.post("/PKECUser/servOrder/cancel?orderCode=" + route.query.orderCode)
        if (res.errorCode === 0) {
          Toast('退款成功')
          init()
        } else {
          Dialog.alert({
            title: '订单不可退款',
            message: '已过7天退款时效或券码已使用',
          }).then(() => {
            init()
          })
        }
      })
    }

    const lookCardDetail = async () => {
      if (state.orderDetail?.orderState == 1) {
        Dialog.confirm({
          title: '提示',
          message: '未成功发券，请联系客服进行处理?',
          confirmButtonText: '联系客服'
        }).then(async () => {
          Dialog.confirm({
            title: '提示',
            message: getServicePhoneText() + '?',
            confirmButtonText: '呼叫'
          }).then(async () => {
            location.href = getServicePhoneTel()
          })
        })
        return
      }
      const res = await axios.get('/PKECUser/servUserRights/findBySourceNo?sourceNo=' + route.query.orderCode)
      if (res.errorCode === 0) {
        console.log(res.data.id)
        router.push({ path: '/dentistry/detail', query: { id: res.data.id } })
      } else {
        Toast(res.errorMessage)
      }
    }

    const toPay = () => {
      const param = {
        localCode: state.orderDetail.servOrderDetails[0].localCode,
        serviceName: state.orderDetail.servOrderDetails[0].skuName,
        htmlCode: state.orderDetail.servOrderDetails[0].htmlCode
      }
      axios.post(`/PKECUser/servOrder/${route.query.orderCode}/payByPKPayProxy`, param).then(payProxyRes => {
        if (payProxyRes.errorCode === 0) {
          location.href = payProxyRes.data.jumpUrl
        } else {
          Toast(payProxyRes.errorMessage)
        }
      })
    }

    return {
      isShowReturnBtn,
      state,
      returnMoney,
      lookCardDetail,
      toPay,
      orderState,
      payWayState,
      getServicePhoneTel
    }
  }
}

const isBeforeAWeek = (momentDate) => {
  const REFERENCE = moment()
  const A_WEEK_OLD = REFERENCE.clone().subtract(-8, 'days').startOf('day')
  // console.log(isBeforeAWeek(moment("2021-08-10")))
  return moment(momentDate).isBefore(A_WEEK_OLD)
}

const orderState = [{
  state: 0,
  text: '待支付',
  // tip: ''
}, {
  // 支付完成未发券   退款 查看卡券
  state: 1,
  text: '已完成',
  // tip: '平台确认预约信息中'
}, {
  // 已发券    退款 查看卡券
  state: 2,
  text: '已完成',
  // tip: '平台确认预约信息中'
}, {
  // 券使用完成    查看卡券
  state: 3,
  text: '已完成',
  // tip: '祝您身体健康，感谢您的使用'
}, {
  state: 4,
  text: '已取消',
  // tip: '取消原因'
}]
const payWayState = [{
  state: 0,
  text: ''
}, {
  state: 1,
  text: '普康宝'
}, {
  state: 2,
  text: '微信'
}, {
  state: 10,
  text: '普康宝+微信'
}]
</script>

<style lang="scss" scoped>
.page {
  overflow: hidden;
  display: flex;
  width: 100vw;
  height: 100vh;
  flex-direction: column;
  .content {
    overflow-y: auto;
    flex: 1;
    .top {
      display: flex;
      height: 160px;
      box-sizing: border-box;
      padding: 1rem 1rem 1.5rem;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      background-color: #ff931f;
      color: #fff;
      .status {
        padding: 1rem 0 0.5rem 0;
        text-align: center;
        .item-text {
          font-size: 1.5rem;
        }
        .tip {
          font-size: 0.8rem;
        }
      }
      .price-box {
        display: flex;
        width: 100vw;
        justify-content: space-around;
        font-size: 1.2rem;
        .item {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
      }
    }
    .box {
      margin: 0 1rem 0.5rem 1rem;
      padding: 0.5rem;
      background-color: #fff;
      border-radius: 5px;
      transform: translateY(-1rem);
      .title {
        font-size: 1rem;
        padding: 0.6rem 0;
        font-weight: bold;
        color: #757474;
      }
      .item {
        display: flex;
        justify-content: space-between;
        font-size: 0.9rem;
        padding: 0.6rem 0;
        border-top: 1px solid #e6e6e6;
        .item-title {
        }
        .item-content {
          color: #989898;
          padding: 0 1rem;
        }
      }
    }
  }

  .bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.4rem 0.4rem;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    background-color: #fff;
    box-sizing: border-box;
    .customer {
      display: flex;
      align-items: center;
      color: #444444;
      display: flex;
      font-size: 0.8rem;
      img {
        padding-right: 0.5rem;
      }
    }
  }
}
</style>